import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { userApiURL } from './apiRoutes';
import { User } from '../models/administration/user-management/user';
import { PaginationObject } from '../models/paginationObject';
import { SortObject } from '../models/sortObject';
import paginationHelper from 'src/app/helpers/pagination';
import sortHelper from 'src/app/helpers/sort';
import { Permissions } from 'src/app/models/administration/user-management/permissions';
import { Bindings } from '../models/administration/user-management/bindings';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(public http: HttpClient) { }

  createUser(data: User): Promise<User> {
    return this.http.post<User>(userApiURL, data).toPromise();
  }

  updateUser(data: User): Promise<User> {
    return this.http.put<User>(userApiURL + '/' + data.identifier, data).toPromise();
  }

  getUser(id: string): Promise<User> {
    return this.http.get<User>(userApiURL + '/' + id).toPromise();
  }

  deleteUser(id: string): Promise<User> {
    return this.http.delete<User>(userApiURL + '/' + id).toPromise();
  }

  getUsers(pageInfo: PaginationObject, sortObject: SortObject[] | null, query: string) {
    return this.http
      .get<any>(userApiURL + paginationHelper.constructPagination(pageInfo) + sortHelper.constructSort(sortObject, true) + query)
      .toPromise();
  }

  getRoles(): Promise<[]> {
    return this.http.get<[]>(userApiURL + '/roles').toPromise();
  }

  getPermissions(): Promise<Permissions[]> {
    return this.http.get<Permissions[]>(userApiURL + '/permissions').toPromise();
  }

  getUserBindings(id: string): Promise<Bindings> {
    return this.http.get<Bindings>(userApiURL + '/' + id + '/bindings').toPromise();
  }

  updateUserBindings(data: Bindings, userId: string): Promise<Bindings> {
    return this.http.post<Bindings>(userApiURL + '/' + userId + '/bindings', data).toPromise();
  }

  getIdentity(token: string): Promise<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Bearer ' + token);
    return this.http.get<any>(userApiURL + '/me', { headers: headers }).toPromise();
  }


}
